module.exports = __webpack_public_path__ + "static/media/patient_male.18a0734b.png";